import WelcomingInterviewContainer, {
  WelcomingInterviewContainerProps,
} from './WelcomingInterviewContainer.component';

export type WelcomingInterviewContainerType = WelcomingInterviewContainerProps;

export default WelcomingInterviewContainer;
